/** Plan K Phase 2 — selectors over the loaded entitlements slice. */

export const selectEntitlementsState = (state) => state.entitlements;
export const selectFeatureKeys = (state) => state.entitlements?.featureKeys || [];
export const selectLaneKeys = (state) => state.entitlements?.laneKeys || [];
export const selectEntitlementsLoaded = (state) => state.entitlements?.loaded === true;
export const selectEntitlementsLoading = (state) => state.entitlements?.loading === true;
export const selectEntitlementsError = (state) => state.entitlements?.error || null;

/** Returns true iff the org has the given feature-level entitlement key. */
export const selectHasFeature = (featureKey) => (state) =>
  Array.isArray(state.entitlements?.featureKeys) &&
  state.entitlements.featureKeys.includes(featureKey);

/** Returns true iff the org has the given lane bundle key (derived). */
export const selectHasLane = (laneKey) => (state) =>
  Array.isArray(state.entitlements?.laneKeys) &&
  state.entitlements.laneKeys.includes(laneKey);
